// Shared money formatting. Pick by output, not by habit:
//   formatCurrency(1234.5)      → "$1,234.50"
//   formatCurrencyWhole(1234.5) → "$1,235"   (dashboards, rankings)
//   formatMoney(undefined)      → "—"        (optional amounts)
const USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const USD_WHOLE = new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0,
});

export const formatCurrency = (amount: number): string => USD.format(amount);

export const formatCurrencyWhole = (amount: number): string => USD_WHOLE.format(amount);

export function formatMoney(value?: number | null): string {
  return Number.isFinite(value) ? USD.format(value!) : '—';
}
